<template>
    <div id="wrapper" class="page">
        <Director-Bar v-if="typePage == 'Production'" index="3"></Director-Bar>
        <Director-Bar v-if="typePage == 'Post'" index="5"></Director-Bar>
        <div id="content-wrapper">
            <div class="container-fluid">
                <!-- <b-link href="#" @click.prevent="openModal">
            <i class="fas fa-plus mr-2"></i> Thêm
          </b-link>-->
                <div class="row" style="margin-left:1px; height: 45px;">
                    <button class="btn btn-info mb-2 mr-2" @click.prevent="openModal">
                        <i class="fas fa-plus"></i> Add
                    </button>

                    <b-form-group class="mb-2 mr-2">
                        <vue-datepicker-local style="width: 100%" v-model="filterMonth" :local="local" clearable
                            format="MM-YYYY" @input="onfilter" @clear="onfilter" />
                    </b-form-group>
                </div>
                <div class="row" style="margin-left:1px; height: 45px;">
                    <b-form-input class="mr-2 " style="flex-grow: 1; width:1px;" v-model="search"
                        placeholder="Search by Name, Position, Position 2" @keydown.enter.prevent="queryItem" size="md" />
                    <button class="btn btn-secondary mb-2 mr-3 ml-2 " style="float:right; height: 37px; width: 93px;"
                        @click.prevent="queryItem">
                        <b-row> <i class="fas fa-search mt-1 mr-2 ml-3"> </i>
                            <p>Search</p>
                        </b-row>


                    </button>
                </div>
                <b-table bordered head-variant="dark" hover responsive striped small table-variant="light"
                    :fields="fields" :items="items">

                    <template v-slot:cell(moneyPerTimeLocal)="data">
                        {{ data.item.moneyPerTimeLocal | numeral('0,0') }}
                    </template>
                    <template v-slot:cell(moneyPerTime)="data">
                        {{ data.item.moneyPerTime | numeral('0,0') }}
                    </template>
                    <template v-slot:cell(tvC30)="data">
                        {{ data.item.tvC30 | numeral('0,0') }}
                    </template>
                    <template v-slot:cell(tvC60)="data">
                        {{ data.item.tvC60 | numeral('0,0') }}
                    </template>
                    <template v-slot:cell(viralClip)="data">
                        {{ data.item.viralClip | numeral('0,0') }}
                    </template>
                    <template v-slot:cell(inhouse)="data">
                        {{ data.item.inhouse | numeral('0,0') }}
                    </template>
                    <template #cell(to)="data">
                        {{ convertToMMYYYY(convertDate(data.item.to)) }}
                    </template>
                    <template #cell(from)="data">
                        {{ convertToMMYYYY(convertDate(data.item.from)) }}
                    </template>
                    <template v-slot:cell(action)="data">
                        <b-link class="text-primary mr-2" href="#" @click.prevent="openUpdateModal(data)">
                            <i class="fas fa-pencil-alt"></i>
                        </b-link>
                        <b-link class="text-danger" href="#" @click.prevent="deleteItem(data)">
                            <i class="fas fa-trash"></i>
                        </b-link>
                        <!-- <button class="btn btn-info mr-1" @click="openUpdateModal(data)" v-if="meeting_udpate">
                <i class="fas fa-pencil-alt"></i>
              </button>
              <button class="btn btn-danger" @click="deleteItem(data)" v-if="meeting_delete">
                <i class="fas fa-trash-alt"></i>
              </button>             -->
                    </template>
                </b-table>
            </div>
        </div>
        <b-modal v-model="modalShow" header-bg-variant="info" header-text-variant="light">
            <template v-slot:modal-title>
                <div v-if="item.id <= 0">Add </div>
                <div v-else>Update </div>
            </template>
            <template v-slot:modal-footer="{ ok, cancel }">
                <b-button variant="info" @click="storeItem()"><i class="fas fa-save mr-2"></i>Save</b-button>
                <b-button variant="secondary" @click="cancel()"><i class="fas fa-times mr-2"></i>Close</b-button>
            </template>
            <b-container>
                <!-- <b-row>
                    <b-col>
                        <b-form-group>
                            <template v-slot:label>Type Bonus<code>*</code></template>
                            <b-row>
                                <b-col>
                                    <b-form-select v-model="item.type" class=" pt-0 pb-0" size="md"
                                        oninvalid="this.setCustomValidity('Please enter Gender')"
                                        oninput="setCustomValidity('')" required>
                                        <b-form-select-option value="Normal">Normal</b-form-select-option>
                                        <b-form-select-option value="TVC">TVC</b-form-select-option>
                                    </b-form-select>
                                </b-col>
                            </b-row>
                        </b-form-group>
                    </b-col>
                </b-row> -->
                <b-row>
                    <b-col>
                        <b-form-group>
                            <template v-slot:label>
                                Name
                                <span class="text-danger">*</span>
                            </template>
                            <b-form-input v-model="item.name" required></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <b-form-group>
                            <template v-slot:label>
                                Content
                                <span class="text-danger">*</span>
                            </template>
                            <b-form-input v-model="item.content" required></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <b-form-group>
                            <template v-slot:label>Company </template>
                            <b-row>
                                <b-col>
                                    <b-form-select v-model="item.company" class=" pt-0 pb-0" size="md"
                                        :options="optionsCompany" value-field="madonvi" text-field="madonvi"
                                        oninvalid="this.setCustomValidity('Please enter Gender')"
                                        oninput="setCustomValidity('')" required>
                                        <b-form-select-option value="All">All</b-form-select-option>
                                    </b-form-select>
                                </b-col>
                            </b-row>
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col>
                        <b-form-group>
                            <template v-slot:label>Position </template>
                            <b-row>
                                <b-col>
                                    <multiselect v-model="item.role" placeholder selectedLabel="are selecting"
                                        select-label="Enter to select" deselectLabel="Enter to remove"
                                        :searchable="true" :options="optionPositions" @select="unlockHopitalCity"
                                        @remove="lockHopitalCity">
                                    </multiselect>
                                </b-col>
                            </b-row>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <b-form-group>
                            <template v-slot:label>Position 2</template>
                            <b-row>
                                <b-col>
                                    <multiselect v-model="item.role2" placeholder selectedLabel="are selecting"
                                        select-label="Enter to select" deselectLabel="Enter to remove"
                                        :searchable="true" :options="optionPositions">
                                    </multiselect>
                                </b-col>
                            </b-row>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <b-form-group>

                            <template>
                                <b-row>
                                    <b-col>
                                        <b-form-group>
                                            <template v-slot:label>Type Threshold</template>
                                            <b-row>
                                                <b-col>
                                                    <b-form-select v-model="item.typeFrequency" class=" pt-0 pb-0"
                                                        size="md"
                                                        oninvalid="this.setCustomValidity('Please enter Gender')"
                                                        oninput="setCustomValidity('')" required>
                                                        <b-form-select-option
                                                            value="Project">Project</b-form-select-option>
                                                        <b-form-select-option value="Day">Day</b-form-select-option>
                                                    </b-form-select>
                                                </b-col>
                                            </b-row>
                                        </b-form-group>
                                    </b-col>
                                    <b-col>
                                        <b-form-group>
                                            <template v-slot:label>Threshold</template>
                                            <b-row>
                                                <b-col>
                                                    <my-currency-input v-model="item.frequency" />
                                                </b-col>
                                            </b-row>
                                        </b-form-group>
                                    </b-col>

                                </b-row>
                            </template>
                        </b-form-group>
                    </b-col>

                </b-row>
                <b-row>
                    <b-col>
                        <b-form-group>
                            <template v-slot:label>Bonus Rate</template>
                            <b-row>
                                <b-col>
                                    <my-currency-input v-model="item.moneyPerTimeLocal" />
                                </b-col>
                            </b-row>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <b-form-group>
                            <template v-slot:label>Inhouse</template>
                            <b-row>
                                <b-col>
                                    <my-currency-input v-model="item.inhouse" />
                                </b-col>
                            </b-row>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row v-if="typePage == 'Production'">
                    <b-col>
                        <b-form-group>
                            <template v-slot:label>Freelance </template>
                            <b-row>
                                <b-col>
                                    <my-currency-input v-model="item.moneyPerTime" />
                                </b-col>
                            </b-row>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row v-if="typePage == 'Post'">
                    <b-col>
                        <b-form-group>
                            <template v-slot:label>TVC(6 - 30s, cutdowns…)</template>
                            <b-row>
                                <b-col>
                                    <my-currency-input v-model="item.tvC30" />
                                </b-col>
                            </b-row>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row v-if="typePage == 'Post'">
                    <b-col>
                        <b-form-group>
                            <template v-slot:label>TVC(45 - 60s) </template>
                            <b-row>
                                <b-col>
                                    <my-currency-input v-model="item.tvC60" />
                                </b-col>
                            </b-row>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row v-if="typePage == 'Post'">
                    <b-col>
                        <b-form-group>
                            <template v-slot:label>Viral Clip </template>
                            <b-row>
                                <b-col>
                                    <my-currency-input v-model="item.viralClip" />
                                </b-col>
                            </b-row>
                        </b-form-group>
                    </b-col>
                </b-row>

                <!-- <b-row>
                    <b-col>
                        <b-form-group>
                            <template v-slot:label>Threshold</template>
                            <b-row>
                                <b-col>
                                    <my-currency-input v-model="item.frequency" />
                                </b-col>
                            </b-row>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <b-form-group>
                            <template v-slot:label>Type Threshold</template>
                            <b-row>
                                <b-col>
                                    <b-form-select v-model="item.typeFrequency" class=" pt-0 pb-0" size="md"
                                        oninvalid="this.setCustomValidity('Please enter Gender')"
                                        oninput="setCustomValidity('')" required>
                                        <b-form-select-option value="Project">Project</b-form-select-option>
                                        <b-form-select-option value="Day">Day</b-form-select-option>
                                    </b-form-select>
                                </b-col>
                            </b-row>
                        </b-form-group>
                    </b-col>
                </b-row> -->

                <b-row>
                    <b-col>
                        <b-form-group>
                            <template v-slot:label> Effective date From - To <code>*</code> </template>
                            <template>
                                <b-row>
                                    <b-col>
                                        <!-- <b-form-input size="md" list="my-list-id" v-model="pitch.BudgetRange" placeholder="Please write the budget range (as per your knowledge)" number="true" required></b-form-input> -->
                                        <vue-datepicker-local style="width: 100%" v-model="item.from" :local="local"
                                            clearable format="MM-YYYY" />
                                    </b-col>
                                    <b-col>
                                        <!-- <b-form-input size="md" list="my-list-id" v-model="pitch.BudgetRange" placeholder="Please write the budget range (as per your knowledge)" number="true" required></b-form-input> -->
                                        <vue-datepicker-local style="width: 100%" v-model="item.to" :local="local"
                                            clearable format="MM-YYYY" />
                                    </b-col>

                                </b-row>
                            </template>
                        </b-form-group>
                    </b-col>

                </b-row>
            </b-container>
        </b-modal>
    </div>
</template>

<script>
import axios from "axios";
import DirectorBar from "../Bonus/Bonus_Bar.vue";
import MyCurrencyInput from "../../components/App/MyCurrencyInput.vue";
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";
import "vue-swatches/dist/vue-swatches.css";
import VueDatepickerLocal from "vue-datepicker-local";
export default {
    name: "Meetings",
    components: {
        DirectorBar,
        Multiselect,
        MyCurrencyInput,
        VueDatepickerLocal
    },
    data() {
        return {
            fields: [],
            fields1: [
                {
                    key: "name",
                    label: "Name",
                    sortable: true,
                },
                {
                    key: "content",
                    label: "Content",
                    sortable: true,
                },
                {
                    key: "company",
                    label: "Company",
                    sortable: true,
                },
                {
                    key: "role",
                    label: "Position",
                    sortable: true,
                },
                {
                    key: "role2",
                    label: "Position 2",
                    sortable: true,
                },
                {
                    key: "typeFrequency",
                    label: "Type Threshold",
                    sortable: true,
                },
                {
                    key: "frequency",
                    label: "Threshold",
                    sortable: true,
                },

                {
                    key: "moneyPerTimeLocal",
                    label: "Bonus Rate",
                    sortable: true,
                },
                {
                    key: "inhouse",
                    label: "Inhouse",
                    sortable: true,
                },
                {
                    key: "moneyPerTime",
                    label: "Freelance ",
                    sortable: true,
                },

                {
                    key: "from",
                    label: "Effective date",
                    sortable: true,

                },
                {
                    key: "to",
                    label: "Expiration date",
                    sortable: true,

                },
                {
                    key: "action",
                    label: "",
                    thStyle: { width: "50px !important" },
                },
            ],
            fields2: [
                {
                    key: "name",
                    label: "Name",
                    sortable: true,
                },
                {
                    key: "content",
                    label: "Content",
                    sortable: true,
                },
                {
                    key: "company",
                    label: "Company",
                    sortable: true,
                },
                {
                    key: "role",
                    label: "Position",
                    sortable: true,
                },
                {
                    key: "role2",
                    label: "Position 2",
                    sortable: true,
                },
                {
                    key: "typeFrequency",
                    label: "Type Threshold",
                    sortable: true,
                },
                {
                    key: "frequency",
                    label: "Threshold",
                    sortable: true,
                },

                {
                    key: "moneyPerTimeLocal",
                    label: "Bonus Rate",
                    sortable: true,
                },
                {
                    key: "inhouse",
                    label: "Inhouse",
                    sortable: true,
                },

                {
                    key: "tvC30",
                    label: "TVC 6~30",
                    sortable: true,
                },
                {
                    key: "tvC60",
                    label: "TVC 45~60",
                    sortable: true,
                },
                {
                    key: "viralClip",
                    label: "ViralClip",
                    sortable: true,
                },



                {
                    key: "from",
                    label: "Effective date",
                    sortable: true,

                },
                {
                    key: "to",
                    label: "Expiration date",
                    sortable: true,

                },
                {
                    key: "action",
                    label: "",
                    thStyle: { width: "50px !important" },
                },
            ],
            local: {
                monthsHead: "January_February_March_April_May_June_July_August_September_October_November_December".split(
                    "_"
                ), // months of head
                months: "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split(
                    "_"
                ), // months of panel
                weeks: "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), // weeks,
            },
            items: [],
            itemsOriginal: [],
            optionsCompany: [],
            optionPositions: [],
            search: "",
            filterMonth: null,
            item_null: {
                id: 0,
                name: "",
                company: "All",
                role: "",
                moneyPerTimeLocal: 0,
                frequency: 1,
                typeFrequency: "",
                moneyPerTime: 0,
                type: "",
                updateBy: "",
                to: null,
                from: null,
                tvC30: 0,
                tvC60: 0,
                viralClip: 0,
                inhouse: 0,
                role2: "",
                content: "",
            },
            item: {
                id: 0,
                name: "",
                company: "",
                role: "",
                moneyPerTimeLocal: 0,
                frequency: 1,
                typeFrequency: "",
                moneyPerTime: 0,
                type: "",
                updateBy: "",
                to: null,
                from: null,
                tvC30: 0,
                tvC60: 0,
                viralClip: 0,
                inhouse: 0,
                role2: "",
                content: "",
            },
            typePage: null,
            modalShow: false,
            url: "/api/Bonus/storePosition",
 
        };
    },
    computed: {

    },
    beforeRouteEnter(to, from, next) {
        //this.typePage = to.params.type;

        axios
            .all([
                axios.get(`/api/Bonus/GetPositions?type=${to.params.type}`),
                axios.get("/api/department"),
                axios.get("/api/picklist?q=vitricongviec"),
            ])
            .then(
                axios.spread((bonusRate, department, optionPositions) => {
                    next((vm) =>
                        vm.initData(bonusRate.data, department.data, optionPositions.data, to.params.type)
                    );
                })
            );
    },
    beforeRouteUpdate(to, from, next) {

            axios
            .get("/api/Bonus/GetPositions", { params: to.query })
            .then((response) => {
                this.items = response.data;
                this.itemsOriginal = response.data;
            })
            .catch((err) => {
                next();
            });
    },
    methods: {
        initData(bonusRate, department, optionPositions, type) {
            //this.$log("Runnnnnnnnnnnnnnnnn");
            this.typePage = type;
            if (this.typePage == "Post") this.fields = this.fields2;
            else this.fields = this.fields1;
            this.items = bonusRate;
            this.optionsCompany = department;
            this.optionPositions = optionPositions.map(obj => obj.pickListValue);
            this.itemsOriginal = bonusRate;
            this.filterMonth = new Date();
            this.onfilter();

        },
        openModal() {
            this.item = JSON.parse(JSON.stringify(this.item_null));
            this.modalShow = true;
        },
        onfilter() {
            //this.$log("testsssss filter" + this.filterMonth);
            this.items = this.itemsOriginal.filter(x => {
                // Convert x.from and x.to to Date objects if they are not already
                const fromDate = x.from instanceof Date ? x.from : new Date(x.from);
                const toDate = x.to instanceof Date ? x.to : new Date(x.to);
                if (!this.filterMonth) {
                    return true; // Include all elements
                }
                const filterMonthYear = this.filterMonth.getFullYear();
                const filterMonthMonth = this.filterMonth.getMonth();
                const fromYear = fromDate.getFullYear();
                const fromMonth = fromDate.getMonth();
                const toYear = toDate.getFullYear();
                const toMonth = toDate.getMonth();
                return ((filterMonthYear > fromYear || (filterMonthYear === fromYear && filterMonthMonth >= fromMonth)) &&
                    (filterMonthYear < toYear || (filterMonthYear === toYear && filterMonthMonth <= toMonth)));
            });
        },
        openUpdateModal(data) {

            this.item = JSON.parse(JSON.stringify(data.item));
            this.$log(this.item);
            this.itemIdex = this.items.indexOf(data.item);
            this.modalShow = true;
        },
        convertDate(value) {
            return this.$convert_date_string(value);
        },

        unlockHopitalCity(city) {
            this.item.role = null;
        },
        lockHopitalCity() {
            this.item.role = null;
        },
        queryItem() {
            let query = Object.assign({}, this.$route.query);      
           
            query.type = this.typePage;
            query.search = this.search;
            //this.item = null;
            this.$router.push({ query: query });
        },
        convertToMMYYYY(dateString) {
            if (dateString == null) return dateString;
            // Split the input string into day, month, and year components
            const [day, month, year] = dateString.split('/');

            // Create a new Date object using the components
            const dateObject = new Date(`${month}/01/${year}`);

            // Get month and year components from the Date object
            const convertedMonth = String(dateObject.getMonth() + 1).padStart(2, '0'); // Months are zero-based
            const convertedYear = dateObject.getFullYear();

            // Return the formatted string
            return `${convertedMonth}-${convertedYear}`;
        },
        storeItem(bvModalEvt) {
            if (this.item.role == null || this.item.role == "") {
                this.$toast.error("Position is empty", "Lỗi", { timeout: 3000 });

                return null;
            }
            this.item.updateBy = this.$store.state.auth.accountId;
            this.item.type = this.typePage;
            if (this.item.id <= 0) {

                axios
                    .post(this.url, this.item)
                    .then((res) => {
                        this.modalShow = false;
                        this.itemsOriginal.push(res.data);
                        this.onfilter();
                        this.$toast.success("Create successfully !", "Successful", {
                            timeout: 3000,
                        });
                    })
                    .catch((err) => {
                        this.$toast.error(err.response.data, "Lỗi", { timeout: 3000 });
                    });
                // }

            } else {


                axios
                    .post(this.url, this.item)
                    .then((res) => {
                        this.modalShow = false;

                        this.items[this.itemIdex] = JSON.parse(
                            JSON.stringify(this.item)
                        );
                        // const temp = JSON.parse(JSON.stringify(this.itemsOriginal));
                        var itemIdex = this.itemsOriginal.findIndex(item => item.id == this.item.id);
                        this.itemsOriginal[itemIdex] = JSON.parse(
                            JSON.stringify(this.item)
                        );
                        //this.$log(test);

                        this.itemIdex = null;
                        this.onfilter();
                        this.$toast.success("Update successfully !", "Successful", {
                            timeout: 3000,
                        });
                    })
                    .catch((err) => {
                        this.$toast.error(err.response.data, "Lỗi", { timeout: 3000 });
                    });


            }
        },
        deleteItem(data) {
            this.$toast.question("Bạn có thực sự muốn xóa không?", "Nhắc nhở", {
                timeout: 20000,
                close: false,
                overlay: true,
                displayMode: "once",
                position: "center",
                buttons: [
                    [
                        "<button><b>Có</b></button>",
                        (instance, toast) => {
                            axios
                                .delete(`/api/Bonus/deletePosition?id=${data.item.id}&deleteBy=${this.$store.state.auth.accountId}`)
                                .then((res) => {
                                    this.items.splice(data.index, 1);
                                    this.$toast.success("Deleted successfully !", "Successful", {
                                        timeout: 3000,
                                    });
                                })
                                .catch((err) => {
                                    this.$toast.error(err.response.data, "ERROR", {
                                        timeout: 3000,
                                    });
                                });
                            instance.hide({ transitionOut: "fadeOut" }, toast, "button");
                        },
                        true,
                    ],
                    [
                        "<button>Không</button>",
                        function (instance, toast) {
                            instance.hide({ transitionOut: "fadeOut" }, toast, "button");
                        },
                    ],
                ],
            });
        },
    },
};
</script>